import React, { useMemo } from 'react';

import { useWebsiteData } from '../../hooks';
import { CollectionView, ProductView } from '../../Product';
import { OrderPage, PaymentStatusPage, UserOrderPage, UserOrdersPage } from '../../Order';
import { PassthroughRoute } from '../PassthroughRoute';

export default function PageProductsRouting() {
    const website = useWebsiteData();
    const contexts = useMemo(
        () => ({
            product: ({ productSlug, collectionSlug }) => ({
                productSlug,
                collectionSlug,
                workspaceId: website.workspace,
                defaultCollectionId: website.defaultCollectionId,
            }),
            collection: ({ collectionSlug }) => {
                const collection = collectionSlug
                    && website.collections.find(({ slug }) => slug === collectionSlug.toLowerCase());

                if (!collection) {
                    return null;
                }

                return {
                    workspaceId: website.workspace,
                    websiteId: website._id,
                    collection,
                };
            },
        }),
        [website.workspace, website.defaultCollectionId, website.collections]
    );

    return (
        <>
            <PassthroughRoute path="/c/:collectionSlug" makeProps={contexts.collection} component={CollectionView} />

            <PassthroughRoute
                path={['/p/:productSlug', '/c/:collectionSlug/p/:productSlug']}
                makeProps={contexts.product}
                component={ProductView}
            />

            <PassthroughRoute path="/user-orders" component={UserOrdersPage} />
            <PassthroughRoute path="/user-orders/:orderId" exact component={UserOrderPage} />
            <PassthroughRoute
                path={[
                    '/orders/:orderId',
                    '/p/:productSlug/orders/:orderId',
                    '/c/:collectionSlug/p/:productSlug/orders/:orderId',
                ]}
                exact
                component={OrderPage}
            />
            <PassthroughRoute path="/orders/:orderId/payment/:status" component={PaymentStatusPage} />
        </>
    );
}
